import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "./App.css";
import Header from "./components/Header";
import About from "./pages/About";
import Founder from "./pages/Founder";
import News from "./pages/News";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import Barathivizha from "./pages/Barathivizha";
import Apv from "./pages/Apv";
import ScrollToTopButton from "./pages/Scrolltotop";
import Noolagapani from "./pages/Noolagapani";
import Podhupani from "./pages/Podhupani";
import Kalvipani from "./pages/Kalvipani";
import Varalatrupani from "./pages/Varalatrupani";
import Meetings from "./pages/meetings";
import Erodebookfair from "./pages/Erodebookfair";
import Specialmeeting from "./pages/Specialmeeting";
import Gallery from "./pages/Gallery";
import Sirappunigal from "./pages/Sirappunigal";
import Piranigal from "./pages/Piranigal";
import Padaipugal from "./pages/Padaipugal";
import Utp from "./pages/Utp";
import Vasagarvattam from "./pages/Vasagarvattam";
import Scrollto from "./pages/Scrollto";
import Veliyeedugal from "./pages/Veliyeedugal";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/Termsandconditions";
import Post from "./pages/Post";
import ErodeBookFair from "./pages/Erode-bookfair";

const pageVariants = {
  initial: { opacity: 0 },
  in: { opacity: 1 },
  out: { opacity: 0 }
};

const pageTransition = {
  duration: 0.5
};

const AnimationWrapper = ({ children }) => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      {children}
    </motion.div>
  );
};

function App() {
  const location = useLocation();

  return (
    <div className="App">
      <ScrollToTopButton />
      <Scrollto />
      <Header />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <AnimationWrapper>
                <Home />
              </AnimationWrapper>
            }
          />
          <Route
            path="/about"
            element={
              <AnimationWrapper>
                <About />
              </AnimationWrapper>
            }
          />
          <Route
            path="/founder"
            element={
              <AnimationWrapper>
                <Founder />
              </AnimationWrapper>
            }
          />
          <Route
            path="/news"
            element={
              <AnimationWrapper>
                <News />
              </AnimationWrapper>
            }
          />
          <Route
            path="/events"
            element={
              <AnimationWrapper>
                <Events />
              </AnimationWrapper>
            }
          />
          <Route
            path="/contact"
            element={
              <AnimationWrapper>
                <Contact />
              </AnimationWrapper>
            }
          />
          <Route
            path="/erode-bookfair"
            element={
              <AnimationWrapper>
                <ErodeBookFair />
              </AnimationWrapper>
            }
          />
          <Route
            path="/barathivizha"
            element={
              <AnimationWrapper>
                <Barathivizha />
              </AnimationWrapper>
            }
          />
          <Route
            path="/asiriyarparatuvizha"
            element={
              <AnimationWrapper>
                <Apv />
              </AnimationWrapper>
            }
          />
          <Route
            path="/noolaga-pani"
            element={
              <AnimationWrapper>
                <Noolagapani />
              </AnimationWrapper>
            }
          />
          <Route
            path="/podhu-pani"
            element={
              <AnimationWrapper>
                <Podhupani />
              </AnimationWrapper>
            }
          />
          <Route
            path="/kalvi-pani"
            element={
              <AnimationWrapper>
                <Kalvipani />
              </AnimationWrapper>
            }
          />
          <Route
            path="/varalatru-pani"
            element={
              <AnimationWrapper>
                <Varalatrupani />
              </AnimationWrapper>
            }
          />
          <Route
            path="/meetings"
            element={
              <AnimationWrapper>
                <Meetings />
              </AnimationWrapper>
            }
          />
          <Route
            path="/erode-bookfair"
            element={
              <AnimationWrapper>
                <Erodebookfair />
              </AnimationWrapper>
            }
          />
          <Route
            path="/specialmeetings"
            element={
              <AnimationWrapper>
                <Specialmeeting />
              </AnimationWrapper>
            }
          />
          <Route
            path="/gallery"
            element={
              <AnimationWrapper>
                <Gallery />
              </AnimationWrapper>
            }
          />
          <Route
            path="/sirapunigalchigal"
            element={
              <AnimationWrapper>
                <Sirappunigal />
              </AnimationWrapper>
            }
          />
          <Route
            path="/piranigalchigal"
            element={
              <AnimationWrapper>
                <Piranigal />
              </AnimationWrapper>
            }
          />
          <Route
            path="/publication"
            element={
              <AnimationWrapper>
                <Padaipugal />
              </AnimationWrapper>
            }
          />
          <Route
            path="/veliyeedugal"
            element={
              <AnimationWrapper>
                <Veliyeedugal />
              </AnimationWrapper>
            }
          />
          <Route
            path="/tamil-creations"
            element={
              <AnimationWrapper>
                <Utp />
              </AnimationWrapper>
            }
          />
          <Route
            path="/vasagarvattam"
            element={
              <AnimationWrapper>
                <Vasagarvattam />
              </AnimationWrapper>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <AnimationWrapper>
                <PrivacyPolicy />
              </AnimationWrapper>
            }
          />
          <Route
            path="/termsandconditions"
            element={
              <AnimationWrapper>
                <TermsAndConditions />
              </AnimationWrapper>
            }
          />
          <Route
            path="/post"
            element={
              <AnimationWrapper>
                <Post />
              </AnimationWrapper>
            }
          />
        </Routes>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

// Wrap App with Router
export default function WrappedApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}
